export const environmentMode: string = "development";
export const serverurl: string = 'https://dev.b-system.ideastream.io';
export const frontendserverurl: string = 'https://dev.f-system.ideastream.io';
export const smallDialogWidth: string = '400px';
export const frontendUrl = 'https://dev.app.ideastream.io';
